const initialState = {
    reportsByRecons: [],
    reportFieldMappings: {
        mappedDataDictionary: [], unMappedDataDictionary: [], reconFieldMappings: [],
    },
    reportReconFieldMaps: [],
    reportReconFieldExpressions: [],
    clonedMappedDict: [],
    reconFieldColumnNames: [],


};
export default initialState;